import { api } from '@/services'

export const create = (rating) => {
  const realEstate = rating.is_real_estate
  return api.post(`${realEstate ? 'web/appointment/createUserFeedback' : 'web/open/userFeedback/create'}`, rating)
}
